import { createAsyncThunk } from '@reduxjs/toolkit';

import { userService } from '@/services';
import { handleThunkApiError } from '@/utils';

export const getUserAccount = createAsyncThunk(
  'user/getUserAccount',
  handleThunkApiError(userService.getUserAccount),
);
